import { FoodCertificationOrderDraftService } from '@aca-new/app/pages/book/pages/food-certification/shared/services/food-certification-order-draft.service';
import { PreviousOrderLinkedRenewalWarnService } from '@aca-new/app/pages/book/pages/food-certification/shared/services/previous-order-linked-renewal-warn.service';
import { IBookFromPreviousOrder, IBookStrategy } from '@aca-new/app/pages/book/shared/models/interfaces/book-strategy.interface';
import { IRenewCertificateResponse } from '@aca-new/app/pages/reports/shared/interfaces/renew-certificate-response.interface';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { AppOverlayService } from '@aca-new/app/shared/services/modal-services/app-overlay/app-overlay.service';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class FoodCertificationBookStrategyService implements IBookStrategy {
  public constructor(
    private readonly _injector: Injector,
    private readonly _router: Router,
    private readonly _overlayService: AppOverlayService,
    private readonly _foodCertificationOrderDraftService: FoodCertificationOrderDraftService,
    private readonly _appUserSettingService: AppUserSettingService,
    private readonly _previousOrderLinkedRenewalWarnService: PreviousOrderLinkedRenewalWarnService
  ) {}

  public getBookFromPreviousUrl(_orderId: string, _serviceType: string): string {
    return '';
  }

  public bookFromPreviousOrder(data: IBookFromPreviousOrder): void {
    const { serviceTypeText } = data.previousOrder.originData;
    const serviceType = serviceTypeText.toLowerCase();
    const isGGAPServiceType = serviceType === EServiceType.GGAP.toLowerCase();
    const isNewGGAPOpen = isGGAPServiceType && this._appUserSettingService.getIsGgapOrderEnabled();

    if (!isGGAPServiceType || isNewGGAPOpen) {
      this._overlayService.updateIsLoading(true);
      const { orderNumber } = data.previousOrder.originData;

      this._foodCertificationOrderDraftService
        .createDraftFromOrder$(data.previousOrder.originData.orderId, serviceType)
        .pipe(
          finalize((): void => {
            this._overlayService.updateIsLoading(false);
            data.onSubmitLoadingChange?.(false);
          }),
          untilDestroyed(this)
        )
        .subscribe({
          next: (response: IRenewCertificateResponse): void => {
            const url = `/book-food-certification/${serviceType}/${response.draftId}?isRenewCert=true`;

            void this._router.navigateByUrl('/', { skipLocationChange: true }).then((canLeave: boolean): void => {
              if (canLeave) {
                void this._router.navigateByUrl(url);
              }
            });
            data.dialogRef?.close();
          },
          error: (error: unknown): void => {
            this._previousOrderLinkedRenewalWarnService.showRecertifyApiError(error, orderNumber);
          },
        });
    } else {
      this._injector.get(AcaMessageService).postMessageToAca({
        type: EPostMessageType.BOOK_FROM_PREVIOUS_ORDER,
        data: { value: data.previousOrder.originData, serviceType: EServiceType.GGAP },
      });
    }
  }
}
